import React from 'react';
import {obterContratoPeloNumero} from '../actions/ContratoActions';
import {buscarNomesArquivosFechamentoPorContrato} from '../actions/NomesArquivosFechamentoAction';
import {connect} from 'react-redux';
import {toast} from 'react-toastify';
import Clipboard from 'react-clipboard.js';
import MapaServices from '../services/mapa';

const CARD = { backgroundColor: "#FFF", borderRadius: 5, width: "100%", display: "flex", flexDirection: "column", padding: 10, boxShadow: "0 1px 1px rgba(0,0,0,0.1)" },
  CABECALHO = { fontSize: 35, fontWeight: "bolder", display: "flex", justifyContent: "center", marginBottom: 5, padding: "0px 20px" },
  CORPO = { display: "flex", flexDirection: "column" },
  TITULO = { fontSize: 12, fontWeight: "bolder", marginBottom: "-5px" },
  BLOCO = { border: "1px solid #d2d6de", borderRadius: 5, padding: 5, fontSize: 13 };

class FecharPublicacao extends React.Component {
  state = {
    contrato: "",
    carregando: false,
    renderizar: false,
    tipos: {
      MIOLO: []
    }
  }

  async procurarContrato (event) {
    event.preventDefault();
    this.setState({carregando: true, renderizar: false, tipos: {MIOLO: []}});
    if (this.state.contrato !== "" && this.state.contrato > 0) {
      await this.props.buscarNomesArquivosFechamentoPorContrato(this.state.contrato);
      let nomesArquivos = this.props.nomesArquivos; 
      if (nomesArquivos.length > 0) {
        await this.exibirOsNomes(nomesArquivos);
      } else {
        let mapa = new MapaServices();
        await mapa.cadastrarNomesArquivosFechamento(this.state.contrato).then(async (response) => {
          if (response.code === 200) {
            await this.props.buscarNomesArquivosFechamentoPorContrato(this.state.contrato);
            await this.exibirOsNomes(this.props.nomesArquivos);
          }
        }).catch(() => {
          toast.error("Este contrato não está cadastrado!");
          this.setState({carregando: false, renderizar: false});
        });
      }
    } else {
      toast.error("É necessário digitar um número maior que zero");
      this.setState({carregando: false, renderizar: false});
    }
  }

  async exibirOsNomes (nomesArquivos) {
    let tipos = this.state.tipos; 
    nomesArquivos.forEach((arquivo) => {
      tipos[arquivo.tipo].push(arquivo.descricao);
    });
    this.setState({carregando: false, renderizar: true, tipos});
  }

  pegarTexto (tipo, i) {
    return this.state.tipos[tipo][i];
  }

  alertaDeItemCopiado () {
    toast.success("Item copiado com sucesso!");
  }

  renderBlocos () {
    return (
      <div className="row">
        <div className="col-md-3 col-sm-4">
          <div style={CARD}>
            <div style={CABECALHO}>MIOLO</div>
            {
              this.state.tipos.MIOLO.map((item, i) => (
                <div key={i} style={CORPO}>
                  <p style={TITULO}>{item.split("_").reverse()[1]} {item.split("_").reverse()[0].split(".")[0]}</p>
                  <p style={BLOCO}>
                    <Clipboard style={{overflowX: "auto", width: "100%", textAlign: "start"}} option-text={this.pegarTexto.bind(this, "MIOLO", i)} onSuccess={this.alertaDeItemCopiado.bind(this)}>
                      <i className="fa fa-clipboard"></i> {item}
                    </Clipboard>
                  </p>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    )
  }

  render () {
    return(
			<div>
				<div className="box">
					<div className="box-body">
						<h3 style={{color: "rgba(0, 0, 0, 0.85)"}}>Buscar Contrato</h3>
						<form onSubmit={this.procurarContrato.bind(this)}>
							<div className="input-group">
								<input type="number" value={this.state.contrato} placeholder="Número do contrato" min="0" onChange={(event) => this.setState({contrato: event.target.value})} className="form-control" />
								<div className="input-group-btn">
									<button type="submit" className="btn btn-flat btn-primary">Buscar contrato</button>
								</div>
							</div>
						</form>
					</div>
				</div>
        {
          this.state.renderizar ? 
            <dov>
              <div className="alert alert-info" style={{fontSize: 18}}>
                Atenção: todos os nomes dos arquivos abaixo foram fechados para impressão <strong>HORIZONTAL</strong> e em <strong>CMYK</strong>. Se o seu arquivo precisar ser fechado para a impressão <strong>VERTICAL</strong>, entre em contato com o setor de desenvolvimento para novas instruções!
              </div>
              {this.renderBlocos()}
            </dov>
          : null
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    contrato: state.contrato.especifico,
    nomesArquivos: state.nomesArquivosFechamento.todos
  }
}

export default connect(mapStateToProps, {obterContratoPeloNumero, buscarNomesArquivosFechamentoPorContrato})(FecharPublicacao);



// WEBPACK FOOTER //
// ./src/views/FecharPublicacao.js